export default __webpack_public_path__ + "static/media/1t.e37a03cc.jpg";